const newOperationCenter = {
  ind: {
    zh: '序号',
    en: 'index',
    pu: 'Número de série.'
  },
  NumberPackages: {
    zh: '包裹数',
    en: 'Number of packages',
    pu: 'Número de pacotes'
  },
  Weight: {
    zh: '重量',
    en: 'Weight',
    pu: 'Peso'
  },
  bigBagNum: {
    zh: '大包号',
    en: '',
    pu: 'Grande bolsa'
  },
  SealedBag: {
    zh: '已封袋',
    en: '',
    pu: 'saco selado'
  },
  haveBeenSigned: {
    zh: '已签收',
    en: '',
    pu: 'Pedido entregue'
  },
  CreationTime: {
    zh: '创建时间',
    en: 'Creation time',
    pu: 'Tempo de criação'
  },
  FaceSheetUrl: {
    zh: '面单url',
    en: '',
    pu: 'URL do formulário do correios'
  },
  LargePackCondition: {
    zh: '大包状态',
    en: '',
    pu: 'Status do saco'
  },
  TotalNumberOfServiceProvider: {
    zh: '服务商总单号',
    en: '',
    pu: 'No. PLP'
  },
  Note: {
    zh: '备注',
    en: 'remark',
    pu: 'observações'
  },
  Lattice: {
    zh: '格口',
    en: 'Lattice',
    pu: 'Reticulado'
  },
  ForecastState: {
    zh: '预报状态',
    en: '',
    pu: 'Situação pendente'
  },
  SuccessfulForecast: {
    zh: '预报成功',
    en: '',
    pu: 'Pendente do sucesso'
  },
  abnormal: {
    zh: '异常',
    en: 'abnormal',
    pu: 'Anormal'
  },
  rule: {
    zh: '规则',
    en: 'Rule',
    pu: 'Regra'
  },
  emptyCompartment: {
    zh: '空置格口',
    en: 'Empty Compartment',
    pu: 'Compartimento Vazio'
  },
  usedCompartment: {
    zh: '已使用格口',
    en: 'Used Compartment',
    pu: 'Compartimento Usado'
  },
  normalCompartmentCount: {
    zh: '正常格口数',
    en: 'Normal Compartment Count',
    pu: 'Número de Compartimentos Normais'
  },
  utilizationRate: {
    zh: '利用率',
    en: 'Utilization Rate',
    pu: 'Utilização'
  },
  abnormalCompartmentCount: {
    zh: '异常格口数',
    en: 'Abnormal Compartment Count',
    pu: 'Número de Compartimentos Anormais'
  },
  normalBagDropCount: {
    zh: '正常落袋包裹数',
    en: 'Normal Bag Drop Package Count',
    pu: 'Número de Pacotes em Sacolas Normais'
  },
  abnormalBagDropCount: {
    zh: '异常落袋包裹数',
    en: 'Abnormal Bag Drop Package Count',
    pu: 'Número de Pacotes em Sacolas Anormais'
  },
  normalSortingVolumeStats: {
    zh: '正常分拣货量统计',
    en: 'Normal Sorting Volume Statistics',
    pu: 'Estatísticas de Volume de Triagem Normal'
  },
  collapseAll: {
    zh: '全部折叠',
    en: 'Collapse All',
    pu: 'Recolher Tudo'
  },
  expandAll: {
    zh: '全部展开',
    en: 'Expand All',
    pu: 'Expandir Tudo'
  },
  preDeliveryHubCount: {
    zh: '预派送网点数量',
    en: 'Pre-Delivery Hub Count',
    pu: 'Número de Centros de Pré-Entrega'
  },
  normalBagDropRatio: {
    zh: '正常落袋货量占比',
    en: 'Normal Bag Drop Volume Ratio',
    pu: 'Proporção de Volume em Sacolas Normais'
  },
  abnormalSortingVolumeStats: {
    zh: '异常分拣货量统计',
    en: 'Abnormal Sorting Volume Statistics',
    pu: 'Estatísticas de Volume de Triagem Anormal'
  },
  abnormalBagDropRatio: {
    zh: '异常落袋货量占比',
    en: 'Abnormal Bag Drop Volume Ratio',
    pu: 'Proporção de Volume em Sacolas Anormais'
  }
};
export { newOperationCenter };
